import { AdditionalWordProps } from '../../types/common'
import { useAppSelector } from '../../utils/agent.store'

const TenantIdBreadcrumb: React.FC<AdditionalWordProps> = ({
  left = '',
  right = '',
}: AdditionalWordProps) => {
  const name_of_organization = useAppSelector(
    (state) => state.authUser.selectedClientTenant?.name_of_organization
  )
  return name_of_organization ? left + name_of_organization + right : null
}

export default TenantIdBreadcrumb
